// Uzbek (latin) — primary UI language for the support dashboard.
export const uz = {
  app: {
    name: "Nasiyah",
    support: "SUPPORT",
    loading: "Yuklanmoqda…",
  },
  nav: {
    sectionMain: "ASOSIY",
    sectionClients: "MIJOZLAR BILAN ISH",
    sectionTools: "VOSITALAR",
    sectionSystem: "TIZIM",
    overview: "Umumiy ko‘rinish",
    metrics: "Metrikalar",
    renewals: "Mijozlar",
    customers: "Foydalanuvchilar",
    import: "Import",
    notifications: "Bildirishnomalar",
    catalogue: "Katalog",
    settings: "Sozlamalar",
    logout: "Chiqish",
    // One-line explanation under each sidebar entry (0153).
    hint: {
      overview: "Tizimning bugungi holati",
      metrics: "O‘sish, daromad, faollik",
      renewals: "Premium merchantlar va muddati",
      customers: "Barcha ro‘yxatdan o‘tganlar",
      import: "Merchant mijoz va shartnomalari",
      catalogue: "Avto va texnika markalari",
      notifications: "Push xabar yuborish",
      settings: "Narxlar va aloqa ma’lumotlari",
    },
  },
  topbar: {
    searchPlaceholder: "Qidirish…",
    menu: "Menyu",
    openMenu: "Menyuni ochish",
    closeMenu: "Menyuni yopish",
    alerts: "Bildirishnomalar",
  },
  table: {
    sortBy: "Saralash",
    sortDefault: "Standart tartib",
    sortAsc: "O‘sish bo‘yicha",
    sortDesc: "Kamayish bo‘yicha",
  },
  placeholder: {
    soon: "Bu bo‘lim hozircha tayyor emas.",
  },
  auth: {
    title: "Support paneli",
    subtitle: "Operator hisobi bilan kiring",
    phoneLabel: "Telefon raqami",
    phonePlaceholder: "+998 90 123 45 67",
    sendCode: "Kod yuborish",
    codeLabel: "Tasdiqlash kodi",
    codeHint: "Telefoningizga yuborilgan 4 xonali kodni kiriting",
    enter: "Kirish",
    back: "Orqaga",
    resend: "Kodni qayta yuborish",
    sending: "Yuborilmoqda…",
    verifying: "Tekshirilmoqda…",
    noPermission: "Sizda support huquqi yo‘q.",
    genericError: "Xatolik yuz berdi. Qayta urinib ko‘ring.",
    invalidPhone: "Telefon raqamini to‘liq kiriting.",
    invalidCode: "Kodni to‘liq kiriting.",
    wrongCode: "Kod noto‘g‘ri yoki muddati o‘tgan.",
  },
  customers: {
    title: "Foydalanuvchilar",
    searchPlaceholder: "Ism, telefon yoki ID bo‘yicha qidirish",
    statusAll: "Barcha holatlar",
    count: "{{count}} foydalanuvchi",
    export: "Eksport",
    import: "Import",
    colCustomer: "Foydalanuvchi",
    colPhone: "Telefon",
    colContracts: "Shartn.",
    colStatus: "Holat",
    colActivity: "Faollik",
    sortContracts: "Shartnomalar soni",
    cardContracts: "{{count}} shartnoma",
    premiumBadge: "Premium",
    edit: "Tahrirlash",
    empty: "Foydalanuvchi topilmadi",
    emptyHint: "Qidiruv yoki filtrlarni o‘zgartirib ko‘ring.",
    clearFilters: "Filtrlarni tozalash",
    loadError: "Ma’lumotlarni yuklab bo‘lmadi.",
    rangeShown: "{{from}}–{{to}} / {{total}} ko‘rsatilmoqda",
    ago: "{{value}} oldin",
    never: "Hech qachon",
    searchLabel: "Foydalanuvchilarni qidirish",
    openCustomer: "{{name}} — kartani ochish",
    prevPage: "Oldingi",
    nextPage: "Keyingi",
    pageLabel: "{{page}}-sahifa",
    pagination: "Sahifalash",
  },
  status: {
    active: "Faol",
    inactive: "Nofaol",
    new: "Yangi",
  },
  drawer: {
    // ── Detail tabs (0068) ──
    tabIdentity: "Ma’lumotlar",
    tabAccount: "Hisob",
    tabTimeline: "Tarix",
    unsavedBadge: "Saqlanmagan o’zgarishlar",
    registeredOn: "ro’yxatdan o’tgan {{date}}",
    verifyBanner:
      "Bu mijoz ma’lumotlari tekshirilishi kerak — identifikatsiya to’liq emas.",
    sectionPersonal: "Shaxsiy ma’lumotlar",
    sectionDocument: "Hujjat",
    sectionAddress: "Manzil",
    sectionAccount: "Hisob",
    firstName: "Ism",
    lastName: "Familiya",
    phone: "Telefon raqami",
    birthDate: "Tug’ilgan sana",
    passport: "Pasport seriyasi",
    pin: "PINFL / JSHSHIR",
    address: "Manzil",
    status: "Holat",
    balance: "Balans",
    premium: "Premium",
    freeTier: "Free tier",
    premiumUntil: "{{date}} gacha",
    premiumFree: "bepul",
    premiumPaid: "pulli",
    premiumRepeatable: "takrorlanuvchi",
    freeRemaining: "qolgan bepul: {{count}}",
    developerBadge: "Developer",
    cancel: "Bekor qilish",
    save: "Saqlash",
    saving: "Saqlanmoqda…",
    loadError: "Mijoz ma’lumotlarini yuklab bo’lmadi.",
    saved: "Mijoz ma’lumotlari saqlandi",
    conflict: "Bu telefon yoki hujjat allaqachon band.",
    saveError: "Saqlashda xatolik. Qayta urinib ko’ring.",
    // ── Locked view / edit mode (0153) ──
    edit: "Tahrirlash",
    lockedHint: "Faqat ko‘rish rejimi. Pasport va PINFL yashirilgan.",
    editingHint: "Tahrirlash rejimi — o‘zgarishlarni saqlang yoki bekor qiling.",
    changedCount: "{{count}} ta maydon o‘zgardi",
    // ── Sensitive operations (0063.04) ──
    opsSection: "Operatsiyalar",
    developerMode: "Developer rejimi",
    makeDeveloper: "Developer rejimini yoqish",
    removeDeveloper: "Developer rejimini o’chirish",
    developerWarning:
      "Yoqilsa, bu foydalanuvchi uchun login tasdiqlash kodi (OTP) sobit 7777 bo’ladi — orqa eshik. Faqat zarur bo’lganda ishlating.",
    addFunds: "Pul qo’shish",
    withdrawFunds: "Pul yechish",
    amount: "Miqdor",
    reason: "Sababi",
    reasonPlaceholder: "ixtiyoriy",
    balanceConfirmCredit: "Balansga {{amount}} so’m qo’shilsinmi?",
    balanceConfirmDebit: "Balansdan {{amount}} so’m yechilsinmi?",
    convertPremium: "Premiumga o’tkazish",
    premiumPaidOption: "Pulli (balansdan yechiladi)",
    premiumFreeOption: "Bepul (qolgan: {{count}})",
    premiumConfirmPaid: "Mijoz balansdan to’lov bilan premiumga o’tkazilsinmi?",
    premiumConfirmFree: "Mijoz bepul premiumga o’tkazilsinmi?",
    confirm: "Tasdiqlash",
    processing: "Bajarilmoqda…",
    opSuccess: "Operatsiya bajarildi",
    balanceLow: "Balans yetarli emas.",
    alreadyPremium: "Bu mijoz allaqachon premium.",
    noFreeLeft: "Bepul premium qolmagan.",
    opError: "Operatsiyani bajarib bo’lmadi. Qayta urinib ko’ring.",
    // ── Unsaved-changes guard (0067.02) ──
    unsavedTitle: "Saqlanmagan o’zgarishlar bor",
    unsavedDiscard: "Bekor qilish",
    unsavedKeep: "Tahrirni davom ettirish",
  },
  timeline: {
    sectionHistory: "Mijoz tarixi",
    sectionSupportActions: "Support amallari",
    empty: "Hozircha yozuv yo‘q",
    registered: "Ro‘yxatdan o‘tdi",
    statusChange: "Holat o‘zgardi",
    developerOn: "Developer rejimi yoqildi",
    developerOff: "Developer rejimi o‘chirildi",
    balanceCredit: "Balans to‘ldirildi",
    balanceDebit: "Balansdan yechildi",
    premiumGranted: "Premium berildi",
    identityCorrected: "Ma’lumotlar tuzatildi",
    by: "{{name}} tomonidan",
    reason: "Sabab: {{reason}}",
  },
  // ── Customer's own app activity (0153) ──
  activity: {
    title: "Ilovadagi faollik",
    period: {
      last5: "Oxirgi 5",
      "7d": "7 kun",
      all: "Hammasi",
    },
    total: "Jami: {{count}}",
    today: "Bugun",
    yesterday: "Kecha",
    loadMore: "Ko‘proq yuklash",
    empty: "Faollik yo‘q",
    emptyHint: {
      last5: "Foydalanuvchi ilovada hali hech narsa qilmagan.",
      "7d": "Oxirgi 7 kunda ilovada harakat bo‘lmagan.",
      all: "Foydalanuvchi ilovada hali hech narsa qilmagan.",
    },
    loadError: "Faollikni yuklab bo‘lmadi.",
    retry: "Qayta urinish",
    app: {
      merchant: "Merchant",
      client: "Mijoz",
    },
    actions: {
      user: {
        login: "Ilovaga kirdi",
        register: "Ro‘yxatdan o‘tdi",
        client_add: "Mijoz qo‘shdi",
        client_remove: "Mijozni o‘chirdi",
        profile_update: "Profilini tahrirladi",
        delete: "Hisobini o‘chirdi",
      },
      loan: {
        create: "Shartnoma tuzdi",
        verify: "Shartnomani mijozga yubordi",
        activate: "Shartnomani qabul qildi",
        reject: "Shartnomani rad etdi",
        pause: "Shartnoma holatini o‘zgartirdi",
        cancel: "Shartnomani bekor qildi",
        finish: "Shartnoma yakunlandi",
        delete: "Shartnomani o‘chirdi",
      },
      payment: {
        create: "To‘lov yubordi",
        part_create: "Qisman to‘lov yubordi",
        several_create: "Bir necha oylik to‘lov yubordi",
        custom_create: "Ixtiyoriy summada to‘lov yubordi",
        approve: "To‘lovni tasdiqladi",
        reject: "To‘lovni rad etdi",
        delay: "To‘lovni kechiktirdi",
        complete: "To‘lov yakunlandi",
        mark_paid: "To‘langan deb belgiladi",
      },
      premium: {
        activate: "Premiumni faollashtirdi",
        renew: "Premiumni yangiladi",
        deactivate: "Premium tugadi",
        free_use: "Bepul premiumdan foydalandi",
      },
      debt: {
        create: "Qarz yozdi",
        update: "Qarzni tahrirladi",
        delete: "Qarzni o‘chirdi",
        settle: "Qarz bo‘yicha hisob-kitob qildi",
        cash_update: "Kassani yangiladi",
      },
    },
    categories: {
      payment: "To‘lov",
      loan: "Shartnoma",
      user: "Profil",
      auth: "Kirish",
      premium: "Premium",
      debt: "Qarz",
    },
    paymentType: {
      FULL: "To‘liq yopish",
      MONTHLY_FULL: "Oylik to‘lov",
      MONTHLY_PART: "Oylikning bir qismi",
      CLOSE_PART: "Qisman yopish",
      DELAYED: "Kechiktirilgan",
      IN_ADVANCE: "Oldindan",
    },
    loanStatus: {
      active: "Faol",
      paused: "To‘xtatilgan",
      pending: "Kutilmoqda",
      draft: "Qoralama",
      finished: "Yakunlangan",
      cancelled: "Bekor qilingan",
      rejected: "Rad etilgan",
    },
    agreement: "Shartnoma #{{id}}",
    payment: "To‘lov #{{id}}",
    debt: "Qarz #{{id}}",
    client: "Mijoz {{code}}",
    amount: "Summa: {{amount}}",
    cash: "Kassa: {{amount}}",
    months: "{{count}} oy",
    newStatus: "Yangi holat: {{status}}",
    nextMonth: "keyingi oyga",
    autoApproved: "avto-tasdiqlangan",
    reason: "Sabab: “{{reason}}”",
  },
  settings: {
    loadError: "Sozlamalarni yuklab bo‘lmadi.",
    saved: "Sozlama saqlandi",
    saving: "Saqlanmoqda…",
    save: "Saqlash",
    unsaved: "Saqlanmagan o‘zgarishlar",
    revert: "Qaytarish",
    premiumTitle: "Premium narxi",
    premiumHint: "Mijoz Premium obunasini sotib olganda balansdan yechiladigan summa.",
    currencySuffix: "so‘m",
    priceInvalid: "Narx 0 yoki undan katta bo‘lishi kerak.",
    supportTitle: "Qo‘llab-quvvatlash havolasi",
    supportHint: "Mijozlar ilovadagi “Yordam” bo‘limidan ochadigan Telegram havolasi.",
    testLink: "Havolani ochib tekshirish",
    linkInvalid: "To‘g‘ri havola kiriting (https:// bilan boshlanishi kerak).",
    phoneTitle: "Qo‘llab-quvvatlash telefoni",
    phoneHint: "Landing sahifada mijozlar ko‘radigan va qo‘ng‘iroq qiladigan telefon raqami.",
    phoneInvalid: "Telefon raqamini xalqaro formatda to‘liq kiriting.",
    freeTierTitle: "Bepul tarif muddati",
    freeTierHint:
      "Operator mijozga bepul Premium berganda necha oy beriladi. O‘zgartirilsa faqat yangi beriladiganlarga ta’sir qiladi — mavjud obunalar o‘zgarmaydi.",
    monthsSuffix: "oy",
    monthsInvalid: "Muddat kamida 1 oy bo‘lishi kerak.",
    saveError: "Saqlashda xatolik. Qayta urinib ko‘ring.",
  },
  import: {
    back: "Orqaga",
    steps: {
      ariaLabel: "Import bosqichlari",
      merchant: "Merchant",
      mode: "Usul",
      data: "Ma'lumot",
      result: "Natija",
    },
    dropzone: {
      label: "Faylni tanlang yoki bu yerga tashlang",
      hint: "Faqat .xlsx va .xls fayllari qabul qilinadi",
      invalidType: "Faqat .xlsx yoki .xls fayl yuklang",
      clear: "Faylni o'chirish",
    },
    merchantStep: {
      title: "Merchant tanlang",
      subtitle: "Import qilmoqchi bo'lgan merchantni tanlang.",
      searchPlaceholder: "Ism yoki telefon bo'yicha qidirish",
      clientCount: "{{count}} mijoz",
      count: "{{count}} ta merchant",
      empty: "Merchant topilmadi",
    },
    modeStep: {
      title: "Import usulini tanlang",
      // Section headings for the two semantic groups
      sectionCustomers: "Mijozlar",
      sectionAgreements: "Shartnomalar",
      fileMode: "Fayldan import",
      fileModeHint: ".xlsx fayl orqali ommaviy import",
      manualMode: "Qo'lda qo'shish",
      manualModeHint: "Bitta mijozni qo'lda kiritish",
      agreementMode: "Shartnomalar import",
      agreementModeHint: ".xlsx fayl orqali shartnomalarni import qilish",
      // New card: add a single agreement manually via side drawer (0119)
      agreementManualMode: "Shartnoma qo'shish",
      agreementManualModeHint: "Bitta shartnomani qo'lda kiriting",
    },
    fileStep: {
      title: "Fayldan import",
      downloadTemplate: "Shablonni yuklab olish",
      dropzone: "Faylni tanlash yoki bu yerga tashlang",
      dropzoneHint: "Faqat .xlsx va .xls fayllari qabul qilinadi",
      readyCount: "Tayyor",
      existsCount: "Mavjud",
      errorCount: "Xato",
      colRow: "#",
      colName: "Ism Familiya",
      colPhone: "Telefon",
      colStatus: "Holat",
      colNote: "Izoh",
      statusReady: "Tayyor",
      statusExists: "Mavjud",
      statusError: "Xato",
      existsHint: "Bu {{field}} allaqachon {{name}}'ga tegishli",
      fieldPhone: "telefon",
      fieldPin: "PINFL",
      commitBtn: "Import qilish ({{count}} ta tayyor)",
      resultTitle: "Import yakunlandi",
      imported: "Import qilindi",
      skipped: "O'tkazib yuborildi",
      errors: "Xatolar",
      newImport: "Yangi import",
      viewCustomers: "Mijozlar ro'yxati",
      noReady: "Tayyor qatorlar yo'q — hech narsa import qilinmaydi. Faylni tekshiring.",
      onlyErrors: "Faqat xatolar ({{count}})",
      importedToast: "{{count}} ta mijoz muvaffaqiyatli import qilindi",
    },
    manualStep: {
      title: "Qo'lda qo'shish",
      first_name: "Ism",
      first_namePlaceholder: "Masalan: Sardor",
      last_name: "Familiya",
      last_namePlaceholder: "Masalan: Xolmatov",
      phone_number: "Telefon raqami",
      phone_numberPlaceholder: "+998901234567",
      pin: "PINFL / JSHSHIR",
      pinPlaceholder: "14 raqamli PINFL",
      passport_number: "Pasport seriyasi",
      passport_numberPlaceholder: "AA1234567",
      birth_date: "Tug'ilgan sana",
      birth_datePlaceholder: "",
      address: "Manzil",
      addressPlaceholder: "Toshkent sh., Chilonzor t., 12-uy",
      submitBtn: "Qo'shish",
      successToast: "{{name}} muvaffaqiyatli qo'shildi",
      sessionCount: "Bu sessiyada {{count}} ta mijoz qo'shildi",
      validation: {
        required: "Bu maydonni to'ldiring",
        phone: "Telefon raqamini to'g'ri kiriting",
        pin: "PINFL 14 ta raqamdan iborat bo'lishi kerak",
      },
    },
    errors: {
      phone_exists: "Bu telefon raqam allaqachon ro'yxatdan o'tgan.",
      pin_exists: "Bu PINFL allaqachon ro'yxatdan o'tgan.",
      passport_exists: "Bu pasport seriyasi allaqachon ro'yxatdan o'tgan.",
      invalid_phone: "Telefon raqami noto'g'ri formatda.",
      invalid_pin: "PINFL noto'g'ri formatda.",
      generic: "Xatolik yuz berdi. Qayta urinib ko'ring.",
    },
    agreements: {
      title: "Shartnomalar importi",
      downloadTemplate: "Shablonni yuklab olish",
      dropzone: "Faylni tanlash yoki bu yerga tashlang",
      dropzoneHint: "Faqat .xlsx va .xls fayllari qabul qilinadi",
      readyCount: "Tayyor",
      existsCount: "Mavjud",
      errorCount: "Xato",
      colRow: "#",
      colClient: "Mijoz",
      colIdentifier: "Identifikator",
      colType: "Tur",
      colName: "Mahsulot/Model",
      colCost: "Tannarx",
      colSellingPrice: "Narxi",
      colDownPayment: "Boshlang'ich",
      colMonthlyPayment: "Oylik to'lov",
      colPaymentCount: "To'lov soni",
      colStartDate: "Boshlanish sanasi",
      colPaymentDay: "To'lov kuni",
      colPaidAmount: "To'langan",
      colNote: "Izoh",
      colReminder: "Eslatish (kun)",
      colMessage: "Holat izohi",
      statusReady: "Tayyor",
      statusExists: "Mavjud",
      statusError: "Xato",
      existsHint: "Shartnoma allaqachon mavjud: {{code}}",
      missingFields: "To'ldirilmagan: {{fields}}",
      // Pre-commit detail drawer trigger (last preview column) + its button tooltip.
      detailCol: "Detal",
      detailBtnTitle: "To'liq detalni ko'rish / to'ldirish",
      editHint: "Hujayralarni bevosita tahrirlashingiz mumkin",
      revalidating: "Tekshirilmoqda…",
      commitBtn: "Import qilish ({{count}} ta tayyor)",
      resultTitle: "Import yakunlandi",
      imported: "Import qilindi",
      skipped: "O'tkazib yuborildi",
      errors: "Xatolar",
      newImport: "Yangi import",
      importedToast: "{{count}} ta shartnoma muvaffaqiyatli import qilindi",
      loanType: {
        car: "Avto",
        building: "Qurilish",
        technology: "Texnika",
        loan: "Qarz",
        other: "Boshqa",
        service: "Xizmat",
      },
      // Pre-commit detail drawer (0085) — context panel with read-only + edit sections.
      detail: {
        contextTitle: "Shartnoma ma'lumotlari",
        editTitle: "Tahrirlash",
      },
      // Edit drawer — opened from the import-result list for each created agreement.
      edit: {
        drawerTitle: "Shartnoma tafsilotlarini tahrirlash",
        editBtn: "Tahrirlash",
        missingHint: "{{count}} ta maydon to'ldirilmagan",
        saveBtn: "Saqlash",
        cancelBtn: "Bekor qilish",
        savedToast: "Tafsilotlar saqlandi",
        loadError: "Ma'lumotlarni yuklab bo'lmadi.",
        saveError: "Saqlashda xatolik. Qayta urinib ko'ring.",
        // Locked money/schedule section shown for context (read-only).
        sectionLocked: "Moliyaviy ma'lumotlar (o'zgartirilmaydi)",
        lockedSellingPrice: "Narxi",
        lockedDownPayment: "Boshlang'ich to'lov",
        lockedMonthlyPayment: "Oylik to'lov",
        lockedPaymentCount: "To'lov soni",
        // Catalogue dropdown labels for model field (car / technology).
        model: "Model",
        modelSearch: "Qidirish...",
        modelPlaceholder: "Modelni tanlang",
        colorPlaceholder: "Rangni tanlang",
        // Per-field labels for additional_data keys (rendered dynamically from editable_fields).
        fields: {
          number: "Davlat raqami",
          vin: "VIN raqami",
          engine_number: "Dvigatel raqami",
          color: "Rangi",
          production_date: "Ishlab chiqarilgan yil",
          mileage: "Yurgan masofasi (km)",
          serial_number: "Seriya raqami",
          comment: "Izoh",
        },
      },
      // Pre-commit detail drawer (0085) — opened from a ready preview row's info button. Reuses
      // edit.fields.* labels and edit.saveBtn/cancelBtn; only the wrapper texts are new.
      previewDetail: {
        drawerTitle: "Shartnoma detali",
        subtitle: "Import qilishdan oldin bo'sh maydonlarni to'ldirishingiz mumkin",
        noFields: "Bu tur uchun qo'shimcha detal maydonlari yo'q",
      },
      // Payment-progress block (Feature A) shown at the top of the edit drawer.
      progress: {
        title: "To'lov jadvali",
        started: "Boshlandi",
        current: "Joriy taksit",
        currentDone: "Tugallangan",
        paid: "To'langan",
        left: "Qolgan taksit",
        finish: "Tugash sanasi",
        remaining: "Qolgan qarz",
        legendDone: "To'langan oy",
        legendPartial: "Qisman (ulush bo'yicha)",
        legendUnpaid: "To'lanmagan",
      },
      // Model-match badge labels shown in the agreement preview table.
      match: {
        legendTitle: "Model mosligi:",
        matched: "katalogda topildi",
        suggested: "taklif",
        unmatched: "katalogda yo'q",
        didYouMean: "Buni nazarda tutdingizmi: {{suggestion}}?",
      },
      // Inline catalogue-add modal (Feature C) — add a brand/model to the global catalogue.
      catalogue: {
        addToCatalogue: "Kataloga qo'shish",
        modalTitle: "Mahsulotni katalogga qo'shish",
        selectBrand: "Markani tanlang",
        newBrand: "Yangi marka",
        selectModel: "Modelni tanlang",
        newModel: "Yangi model",
        add: "Qo'shish",
        confirm: "Tasdiqlash",
        cancel: "Bekor qilish",
        brandAdded: "Marka qo'shildi",
        modelAdded: "Model qo'shildi",
      },
    },
    // ── Single-agreement manual add drawer (0119) ──────────────────────────
    agreementAdd: {
      drawerTitle: "Shartnoma qo'shish",
      customerSection: "Mijoz",
      agreementSection: "Shartnoma",
      customer: {
        existing: "Mavjud mijoz",
        new: "Yangi mijoz",
        selectPlaceholder: "Mijozni tanlang",
        searchPlaceholder: "Ism yoki telefon bo'yicha qidirish",
        searchHint: "Qidirish uchun yozing",
        empty: "Mijoz topilmadi",
        change: "O'zgartirish",
      },
      fields: {
        type: "Turi",
        name: "Mahsulot nomi",
        namePlaceholder: "Masalan: Muzlatgich",
        model: "Model",
        modelPlaceholder: "Modelni tanlang",
        modelSearch: "Qidirish...",
        color: "Rangi",
        colorPlaceholder: "Rangni tanlang",
        cost_price: "Tannarx",
        selling_price: "Narxi",
        down_payment: "Boshlang'ich to'lov",
        monthly_payment: "Oylik to'lov",
        payment_count: "To'lov soni",
        paid_amount: "To'langan",
        payment_day: "To'lov kuni",
        first_payment_date: "Birinchi to'lov sanasi",
        notification_before: "Necha kun oldin eslatish",
        note: "Izoh",
        monthlyAvgHint: "O'rtacha oylik: {{amount}}",
        cost_pricePlaceholder: "Masalan: 800",
        selling_pricePlaceholder: "Masalan: 1 000",
        down_paymentPlaceholder: "Masalan: 200",
        monthly_paymentPlaceholder: "Masalan: 100",
        payment_countPlaceholder: "Masalan: 12",
        paid_amountPlaceholder: "Masalan: 100",
        payment_dayPlaceholder: "Masalan: 15",
        first_payment_datePlaceholder: "Sanani tanlang",
        notification_beforePlaceholder: "Masalan: 3",
        notePlaceholder: "Qo'shimcha izoh (ixtiyoriy)",
      },
      // "To'langan" input mode toggle (0123): money sum vs. number of monthly instalments paid.
      paidMode: {
        amount: "Summa",
        count: "To'lovlar soni",
        countPlaceholder: "Masalan: 3",
        moneyHint: "= {{amount}} so'm",
        needMonthly: "Avval oylik to'lovni kiriting",
      },
      validation: {
        required: "Bu maydonni to'ldiring",
        customerRequired: "Mijozni tanlang yoki yangi mijoz ma'lumotlarini kiriting",
      },
      submitBtn: "Saqlash",
      reviewBtn: "Ko'rib chiqish",
      cancelBtn: "Bekor qilish",
      successToast: "Shartnoma qo'shildi: {{code}}",
      sessionCount: "Bu sessiyada {{count}} ta shartnoma qo'shildi",
      // Contract preview ("dogovor") shown before saving — mirrors the merchant app's preview screen.
      preview: {
        title: "Shartnoma",
        subtitle: "Tasdiqlashdan oldin tekshiring",
        clientSection: "Mijoz",
        agreementSection: "Shartnoma",
        financialSection: "Moliyaviy",
        scheduleSection: "To'lov jadvali",
        notificationSection: "Eslatma",
        clientName: "F.I.Sh.",
        clientPhone: "Telefon",
        clientPassport: "Passport",
        clientPin: "JSHSHIR",
        confirmBtn: "Tasdiqlash",
        editBtn: "Tahrirlash",
        downloadBtn: "Yuklab olish",
        pdfError: "PDF hozircha mavjud emas — quyida ma'lumotlar ko'rsatilgan",
      },
    },
    // ── Searchable colour picker (0120) ────────────────────────────────────
    colorSelect: {
      search: "Rang qidirish...",
    },
    // ── Import history panel (0116.04) ──────────────────────────────────────
    importHistory: {
      title: "So'nggi importlar",
      colDate: "Sana",
      colActor: "Operator",
      colMerchant: "Merchant",
      colFilename: "Fayl",
      colImported: "Import",
      colSkipped: "O'tkazildi",
      colErrors: "Xato",
      colTotal: "Jami",
      empty: "Hali hech qanday import amalga oshirilmagan",
      loading: "Yuklanmoqda…",
      noFile: "—",
      expand: "Agreementlarni ko'rish",
      collapse: "Yopish",
      noDetail: "Bu yozuvda detal mavjud emas",
    },
  },
  notifications: {
    composeTitle: "Yangi bildirishnoma",
    // Recipients
    recipientsLabel: "Qabul qiluvchilar",
    recipientAll: "Barcha mijozlar",
    recipientSegment: "Segment",
    recipientSingle: "Bitta mijoz",
    // Segment filters (status × premium — mirrors backend UserStatus)
    segStatus: "Holat",
    segStatusAll: "Barcha mijozlar",
    segStatusActive: "Faol mijozlar",
    segStatusInactive: "Nofaol mijozlar",
    segStatusNew: "Yangi mijozlar",
    segPremium: "Faqat Premium mijozlar",
    // Single recipient (merchant picker — GET /support/merchants/?search=)
    singleSelect: "Merchantni tanlang",
    singlePlaceholder: "Ism yoki telefon bo‘yicha qidirish…",
    merchantPickHint: "Bittasini tanlash uchun ismi yoki raqamini yozing.",
    merchantNotFound: "Merchant topilmadi.",
    merchantChange: "O‘zgartirish",
    merchantClients: "{{n}} ta mijoz",
    // Channel
    channelLabel: "Kanal",
    channelPush: "Push",
    channelSms: "SMS",
    channelBoth: "Ikkalasi",
    channelBothTable: "Push + SMS",
    // Content language (task 0081 — UZ va RU ikkalasi ham majburiy)
    contentLang: "Til",
    langUz: "O‘zbekcha",
    langRu: "Ruscha",
    fillBothLangs: "Yuborish uchun ikkala tilni (UZ va RU) to‘ldiring.",
    // Title + body
    title: "Sarlavha",
    titleHint: "— ilovada qalin ko‘rinadi",
    titlePlaceholder: "To‘lov eslatmasi",
    bodyLabel: "Matn",
    bodyPlaceholder: "Mijozlarga yetkazmoqchi bo‘lgan xabaringiz",
    bodyHelp: "Siz/Вы shaklida yozing",
    // Personalization chip — inserts the {name} token at the cursor; backend swaps it per recipient.
    insertNameChip: "Ism qo‘shish",
    insertNameHint: "Yuborishda har bir mijozning ismiga aylanadi.",
    // Send time
    sendTimeLabel: "Yuborish vaqti",
    sendNow: "Hozir yuborish",
    sendNowHint: "Tasdiqlangandan so‘ng darhol",
    sendSchedule: "Rejalashtirish",
    sendScheduleHint: "Sana va vaqtni belgilang",
    scheduleAtLabel: "Yuborish sanasi va vaqti",
    scheduleFutureError: "Vaqt kelajakda bo‘lishi kerak.",
    // Footer
    saveDraft: "Qoralama saqlash",
    draftSaved: "Qoralama saqlandi",
    send: "Yuborish",
    sending: "Yuborilmoqda…",
    // Preview
    previewLabel: "Ko‘rinish",
    previewNow: "Hozir",
    previewTitlePlaceholder: "Sarlavha",
    previewBodyPlaceholder: "Bildirishnoma matni",
    // Stats
    statsUnit: "qabul qiluvchi",
    statsRealNote: "Qabul qiluvchilar soni yuborilgandan so‘ng aniqlanadi.",
    reachPush:
      "Push orqali ~{{reach}} ta qurilmaga yetkaziladi. Push o‘chirilgan mijozlarga yuborilmaydi.",
    reachSms: "SMS orqali {{total}} ta raqamga yuboriladi.",
    reachBoth: "Push + SMS orqali {{total}} ta mijozga yuboriladi.",
    // Confirm
    confirmTitle: "Bildirishnomani yuborish?",
    confirmBody:
      "Bu bildirishnoma {{n}} ta mijozga yuboriladi. Bu amalni ortga qaytarib bo‘lmaydi.",
    confirmBodyNoCount:
      "Bu bildirishnoma tanlangan qabul qiluvchilarga yuboriladi. Bu amalni ortga qaytarib bo‘lmaydi.",
    confirmYes: "Ha, yuborish",
    cancel: "Bekor qilish",
    sent: "Bildirishnoma yuborildi",
    // History table
    historyTitle: "Yuborilgan bildirishnomalar",
    colTitle: "Sarlavha",
    colRecipients: "Qabul qiluvchilar",
    colChannel: "Kanal",
    colDelivered: "Yetkazildi",
    colDate: "Sana",
    colStatus: "Holat",
    statusSent: "Yuborildi",
    statusScheduled: "Rejalashtirilgan",
    statusDraft: "Qoralama",
    statusCancelled: "Bekor qilingan",
    // Cancel a still-pending scheduled broadcast
    cancelScheduled: "Bekor qilish",
    cancelling: "Bekor qilinmoqda…",
    cancelled: "Rejalashtirilgan xabar bekor qilindi",
    empty: "Hali bildirishnoma yuborilmagan",
    emptyHint: "Yuborilgan bildirishnomalar shu yerda ko‘rinadi.",
    loadError: "Bildirishnomalarni yuklab bo‘lmadi.",
    // Inline errors
    contentRequired: "Ikkala til uchun ham sarlavha va matnni to‘ldiring.",
    forbidden: "Sizda bildirishnoma yuborish huquqi yo‘q.",
    sendError: "Yuborishda xatolik. Qayta urinib ko‘ring.",
    // Guided steps
    stepMessage: "Xabar matni",
    // Per-language helpers (tab + smart help)
    copyToRu: "Ruschaga nusxa",
    copyToUz: "O‘zbekchaga nusxa",
    copied: "Matn ikkinchi tilga nusxalandi",
    incompleteWarnUz: "O‘zbekcha matn hali to‘ldirilmagan",
    incompleteWarnRu: "Ruscha matn hali to‘ldirilmagan",
    // Readiness checklist
    readyTitle: "Yuborishga tayyormi?",
    readyRecipient: "Qabul qiluvchi tanlandi",
    readyUz: "O‘zbekcha matn to‘ldirildi",
    readyRu: "Ruscha matn to‘ldirildi",
    readyTiming: "Yuborish vaqti belgilandi",
  },
  time: {
    minutes: "{{count}} daqiqa",
    hours: "{{count}} soat",
    days: "{{count}} kun",
    justNow: "hozirgina",
  },
  catalogue: {
    title: "Katalog",
    searchPlaceholder: "Marka bo'yicha qidirish",
    car: "Avto",
    technology: "Texnika",
    addBrand: "Marka qo'shish",
    addModel: "Model qo'shish",
    brandNameLabel: "Marka nomini kiriting",
    modelNameLabel: "Model nomini kiriting",
    colBrand: "Marka",
    colModel: "Model",
    colModels: "Modellar",
    edit: "Tahrirlash",
    delete: "O'chirish",
    rename: "Nomini o'zgartirish",
    save: "Saqlash",
    cancel: "Bekor qilish",
    confirm: "Tasdiqlash",
    add: "Qo'shish",
    deleteBrandTitle: "Markani o'chirish",
    deleteBrandHint: "Bu marka va unga tegishli {{count}} ta model katalogdan yashiriladi. Mavjud shartnomalar o'z nomini saqlaydi; xohlasangiz keyinroq qaytarish mumkin.",
    deleteModelTitle: "Modelni o'chirish",
    deleteModelHint: "Bu model katalogdan yashiriladi. Mavjud shartnomalar o'z nomini saqlaydi; xohlasangiz keyinroq qaytarish mumkin.",
    empty: "Hali marka qo'shilmagan",
    emptyHint: "Birinchi markani quyida qo'shing.",
    noResults: "Qidiruv bo'yicha marka topilmadi",
    loadError: "Ma'lumotlarni yuklab bo'lmadi.",
    saved: "Saqlandi",
    deleted: "O'chirildi",
    error: "Xatolik yuz berdi. Qayta urinib ko'ring.",
    brandsCount: "{{count}} ta marka",
    modelsCount: "{{count}} ta model",
    selectBrandTitle: "Marka tanlanmagan",
    selectBrand: "Modellarni ko'rish, tahrirlash yoki qo'shish uchun chapdan marka tanlang.",
    noModels: "Bu markada hali model yo'q",
    noModelsHint: "Birinchi modelni quyida qo'shing.",
    addModelPlaceholder: "Model nomi — Enter bilan qo'shish",
    addBrandPlaceholder: "Yangi marka nomi — Enter bilan qo'shish",
    colors: "Ranglar",
    colorsCount: "{{count}} ta rang",
    addColorPlaceholder: "Yangi rang nomi",
    addColorNameRuPlaceholder: "Ruscha nomi (ixtiyoriy)",
    noColors: "Hozircha rang yo'q",
    noColorsHint: "Quyida yangi rang qo'shing",
    deleteColorTitle: "Rangni o'chirish",
    deleteColorHint: "Bu rang ro'yxatdan olib tashlanadi. Mavjud shartnomalar o'zgarmaydi.",
  },
  overview: {
    title: "Umumiy ko'rinish",
    subtitle: "Operator kokpiti — tizimning joriy holati",
    customers: "Mijozlar",
    activeAgreements: "Faol shartnomalar",
    overdue: "Muddati o'tgan to'lovlar",
    outstandingDebt: "Qoldiq qarz",
    merchants: "Merchantlar",
    premium: "Premium mijozlar",
    circulating: "Aylanmadagi mablag'",
    profit: "Foyda",
    newThisMonth: "bu oy",
    clientsSuffix: "mijoz",
    som: "so'm",
    last6Months: "So'nggi 6 oy",
    recentActivity: "So'nggi faollik",
    recentNotifications: "So'nggi bildirishnomalar",
    recentCustomers: "Yangi mijozlar",
    quickActions: "Tezkor amallar",
    qaImport: "Import",
    qaNotify: "Bildirishnoma",
    qaCustomers: "Mijozlar",
    empty: "Ko'rsatiladigan ma'lumot yo'q",
    loadError: "Ma'lumotlarni yuklab bo'lmadi",
    loadErrorHint: "Sahifani yangilang yoki qayta urinib ko'ring.",
  },
  metrics: {
    title: "Metrikalar",
    tabs: {
      growth: "O‘sish",
      agreements: "Shartnomalar",
      premium: "Premium",
      engagement: "Faollik",
    },
    presets: {
      "7d": "7 kun",
      "30d": "30 kun",
      "90d": "90 kun",
      "12m": "12 oy",
      custom: "Ixtiyoriy",
    },
    filter: {
      from: "Boshlanish sanasi",
      to: "Tugash sanasi",
      prevPeriod: "Oldingi davr: {{from}} – {{to}}",
    },
    unit: {
      som: "so‘m",
      min: "daq",
      hour: "soat",
      day: "kun",
    },
    common: {
      retry: "Qayta urinish",
      loadError: "Metrikalarni yuklab bo‘lmadi",
      loadErrorHint: "Qayta urinib ko‘ring yoki sahifani yangilang.",
      empty: "Bu davr uchun ma’lumot yo‘q",
      snapshot: "Joriy holat",
      dataSince: "Faollik ma’lumoti {{date}} dan beri",
      appUpdateHint: "Mobil ilova yangilanishidan keyin ko‘rinadi",
      vsPrev: "oldingi davrga nisbatan",
      count: "Soni",
      share: "Ulush",
      total: "Jami",
    },
    sections: {
      trend: "Dinamika",
      totals: "Umumiy",
      byStatus: "Holat bo‘yicha",
      byType: "Tur bo‘yicha",
      source: "Manba",
      active: "Faol premium",
      expiring: "Yaqinda tugaydigan premium (7 kun)",
      byApp: "Ilova bo‘yicha",
      retention: "Retention",
      cohorts: "Haftalik kogortalar",
      funnel: "Voronka",
      adoption: "Funksiyalardan foydalanish",
      platforms: "Platformalar",
      appVersions: "Ilova versiyalari",
    },
    kpi: {
      newMerchants: "Yangi merchantlar",
      newMerchantsHint: "Davrda birinchi marta merchant sifatida qo‘shilgan foydalanuvchilar.",
      newClients: "Yangi mijozlar",
      newClientsHint: "Davrda birinchi marta mijoz sifatida qo‘shilgan foydalanuvchilar.",
      activeMerchants: "Faol merchantlar",
      activeMerchantsHint: "Davrda kamida bitta (qoralama bo‘lmagan) shartnoma yaratgan merchantlar.",
      clientAppActivation: "Mijoz ilovasi aktivatsiyasi",
      clientAppActivationHint: "Ilovaga kirgan mijozlar / jami mijozlar. Joriy holat, oldingi davr bilan solishtirilmaydi.",
      totalMerchants: "Jami merchantlar",
      totalClients: "Jami mijozlar",
      newAgreements: "Yangi shartnomalar",
      newAgreementsHint: "Davrda yaratilgan va qoralama bo‘lmagan shartnomalar.",
      volume: "Hajm",
      volumeHint: "Shu shartnomalar sotuv narxi yig‘indisi (so‘mda).",
      acceptanceRate: "Qabul qilish darajasi",
      acceptanceRateHint: "Davrda qaror qilingan shartnomalar ichida faollashtirilganlar ulushi (faol / (faol + rad etilgan)).",
      medianAcceptMinutes: "Qabul qilish vaqti (medyana)",
      medianAcceptMinutesHint: "Tasdiqlash so‘rovidan faollashtirishgacha o‘tgan vaqt medyanasi. Kamroq yaxshiroq.",
      revenue: "Daromad",
      revenueHint: "Davrda premium uchun muvaffaqiyatli to‘langan summa.",
      topups: "To‘ldirishlar",
      topupsHint: "Davrda balansni muvaffaqiyatli to‘ldirishlar summasi.",
      paidActivations: "Pullik aktivatsiyalar",
      paidActivationsHint: "Davrda pullik premium faollashtirishlar soni.",
      freeActivations: "Bepul aktivatsiyalar",
      freeActivationsHint: "Davrda bepul premium faollashtirishlar soni.",
      freeToPaid: "Bepul → pullik",
      freeToPaidHint: "Bepul premiumi davrda tugaganlar ichida keyin pullik xarid qilganlar ulushi.",
      dauAvg: "O‘rtacha DAU",
      dauAvgHint: "Davrning har kunidagi noyob faol foydalanuvchilar o‘rtachasi.",
      wau: "WAU",
      wauHint: "Davrning oxirgi 7 kunidagi noyob faol foydalanuvchilar.",
      mau: "MAU",
      mauHint: "Davrning oxirgi 30 kunidagi noyob faol foydalanuvchilar.",
      stickiness: "Stickiness",
      stickinessHint: "DAU / MAU — foydalanuvchilar ilovaga qanchalik tez-tez qaytishi.",
      d1: "D1",
      d1Hint: "Birinchi faol kundan keyingi 1-kuni qaytganlar ulushi.",
      d7: "D7",
      d7Hint: "Birinchi faol kundan keyingi 7-kuni qaytganlar ulushi.",
      d30: "D30",
      d30Hint: "Birinchi faol kundan keyingi 30-kuni qaytganlar ulushi.",
      cohortSize: "Kogorta hajmi",
    },
    series: {
      newMerchants: "Yangi merchantlar",
      newClients: "Yangi mijozlar",
      count: "Soni",
      volume: "Hajm",
      revenue: "Daromad",
      topups: "To‘ldirishlar",
      merchant: "Merchant",
      client: "Mijoz",
      total: "Jami",
    },
    status: {
      active: "Faol",
      rejected: "Rad etilgan",
      paused: "To‘xtatilgan",
      pending: "Kutilmoqda",
      draft: "Qoralama",
      finished: "Yakunlangan",
      cancelled: "Bekor qilingan",
    },
    type: {
      car: "Avtomobil",
      building: "Ko‘chmas mulk",
      technology: "Texnika",
      loan: "Qarz",
      other: "Boshqa",
      service: "Xizmat",
    },
    sourceKind: {
      app: "Ilova",
      imported: "Import",
    },
    platform: {
      ios: "iOS",
      android: "Android",
      web: "Web",
      unknown: "Noma’lum",
    },
    app: {
      merchant: "Merchant",
      client: "Mijoz",
    },
    funnel: {
      signup: "Ro‘yxatdan o‘tish",
      profile: "Profil to‘ldirildi",
      first_client: "Birinchi mijoz",
      first_agreement: "Birinchi shartnoma",
      paid_premium: "Pullik premium",
      ofPrev: "oldingi qadamdan",
    },
    adoption: {
      activeMerchants: "Faol merchantlar",
      agreements: "Shartnoma yaratganlar",
      payments: "To‘lov kiritganlar",
      debts: "Qarzlardan foydalanganlar",
      clients: "Mijoz qo‘shganlar",
      clientPaymentShare: "To‘lovlarning mijoz tomonidan kiritilgan ulushi",
    },
    premium: {
      total: "Jami faol",
      paid: "Pullik",
      free: "Bepul",
      willRenew: "Uzaytiriladi",
      wontRenew: "Uzaytirilmaydi",
      colName: "Ism",
      colPhone: "Telefon",
      colEnd: "Tugash sanasi",
      colType: "Tur",
      colRenew: "Avtouzaytirish",
      colBalance: "Balans",
      viewAll: "Hammasini ko‘rish →",
    },
    cohort: {
      week: "Hafta",
      size: "Hajm",
      weekN: "{{n}}-hafta",
    },
  },
  renewals: {
    title: "Mijozlar",
    subtitle:
      "Premium muddati yaqinlashgan yoki tugagan merchantlar — faolligiga qarab, Pro’ga o‘tkazish yoki yangilash uchun qo‘ng‘iroq qiling",
    statusExpiring: "Tugayapti",
    statusExpired: "Tugagan",
    daysLabel: "Muddat oralig‘i",
    daysOption: "{{n}} kun",
    kindLabel: "Premium turi",
    kind_all: "Hammasi",
    kind_free: "Free",
    kind_paid: "Pullik",
    searchPlaceholder: "Ism yoki telefon bo‘yicha qidirish",
    total: "Jami: {{count}}",
    rangeShown: "{{from}}–{{to}} / {{total}} ko‘rsatilmoqda",
    colMerchant: "Merchant",
    colPremium: "Premium",
    colTerm: "Muddat",
    colAgreements: "Shartnomalar",
    colClients: "Mijozlar",
    colActivity: "Faollik",
    agreementsHint: "Hozir faol shartnomalar soni. Pastda — ularning hali to‘lanmagan qoldig‘i (USD).",
    clientsHint: "Ma’lumotlari to‘liq (ism, familiya, PINFL, pasport, manzil, tug‘ilgan sana) va kamida bitta shartnomani qabul qilgan mijozlar. Pastda — jami mijozlar.",
    activityHint: "Oxirgi kirish vaqti. Chiziq — oxirgi 30 kunda nechta kun faol bo‘lgani.",
    activeShort: "faol",
    clientsTotal: "jami {{n}} ta",
    neverLoggedIn: "Hech kirmagan",
    free: "Free",
    paid: "Pullik",
    endsToday: "Bugun tugaydi",
    daysLeft: "{{n}} kun qoldi",
    endedAgo: "{{n}} kun oldin tugadi",
    new30d: "+{{n}} 30 kunda",
    activeDays: "Oxirgi 30 kunda {{n}} kun faol",
    copy: "Raqamni nusxalash",
    copied: "Nusxa olindi",
    openMerchant: "{{name}} — kartani ochish",
    empty: "Merchant topilmadi",
    emptyHint: "Filtrlarni o‘zgartirib ko‘ring.",
    loadError: "Ma’lumotlarni yuklab bo‘lmadi.",
    retry: "Qayta urinish",
  },
};

export type Translation = typeof uz;
